function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/*!
 * Signature Pad v5.1.1 | https://github.com/szimek/signature_pad
 * (c) 2025 Szymon Nowak | Released under the MIT license
 */
// src/point.ts
var Point = /*#__PURE__*/function () {
  function Point(x, y, pressure, time) {
    _classCallCheck(this, Point);

    _defineProperty(this, "x", void 0);

    _defineProperty(this, "y", void 0);

    _defineProperty(this, "pressure", void 0);

    _defineProperty(this, "time", void 0);

    if (isNaN(x) || isNaN(y)) {
      throw new Error("Point is invalid: (".concat(x, ", ").concat(y, ")"));
    }

    this.x = +x;
    this.y = +y;
    this.pressure = pressure || 0;
    this.time = time || Date.now();
  }

  _createClass(Point, [{
    key: "distanceTo",
    value: function distanceTo(start) {
      return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
    }
  }, {
    key: "velocityFrom",
    value: function velocityFrom(start) {
      return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
    }
  }]);

  return Point;
}(); // src/bezier.ts


var Bezier = /*#__PURE__*/function () {
  function _Bezier(startPoint, control2, control1, endPoint, startWidth, endWidth) {
    _classCallCheck(this, _Bezier);

    this.startPoint = startPoint;
    this.control2 = control2;
    this.control1 = control1;
    this.endPoint = endPoint;
    this.startWidth = startWidth;
    this.endWidth = endWidth;
  }

  _createClass(_Bezier, [{
    key: "length",
    value: // Returns approximated length. Code taken from https://www.lemoda.net/maths/bezier-length/index.html.
    function length() {
      var steps = 10;
      var length = 0;
      var px;
      var py;

      for (var i = 0; i <= steps; i += 1) {
        var t = i / steps;
        var cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
        var cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);

        if (i > 0) {
          var xdiff = cx - px;
          var ydiff = cy - py;
          length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
        }

        px = cx;
        py = cy;
      }

      return length;
    } // Calculate parametric value of x or y given t and the four point coordinates of a cubic bezier curve.

  }, {
    key: "point",
    value: function point(t, start, c1, c2, end) {
      return start * (1 - t) * (1 - t) * (1 - t) + 3 * c1 * (1 - t) * (1 - t) * t + 3 * c2 * (1 - t) * t * t + end * t * t * t;
    }
  }], [{
    key: "fromPoints",
    value: function fromPoints(points, widths) {
      var c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
      var c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
      return new _Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
    }
  }, {
    key: "calculateControlPoints",
    value: function calculateControlPoints(s1, s2, s3) {
      var dx1 = s1.x - s2.x;
      var dy1 = s1.y - s2.y;
      var dx2 = s2.x - s3.x;
      var dy2 = s2.y - s3.y;
      var m1 = {
        x: (s1.x + s2.x) / 2,
        y: (s1.y + s2.y) / 2
      };
      var m2 = {
        x: (s2.x + s3.x) / 2,
        y: (s2.y + s3.y) / 2
      };
      var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
      var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
      var dxm = m1.x - m2.x;
      var dym = m1.y - m2.y;
      var k = l1 + l2 == 0 ? 0 : l2 / (l1 + l2);
      var cm = {
        x: m2.x + dxm * k,
        y: m2.y + dym * k
      };
      var tx = s2.x - cm.x;
      var ty = s2.y - cm.y;
      return {
        c1: new Point(m1.x + tx, m1.y + ty),
        c2: new Point(m2.x + tx, m2.y + ty)
      };
    }
  }]);

  return _Bezier;
}(); // src/signature_event_target.ts


var SignatureEventTarget = /*#__PURE__*/function () {
  /* tslint:enable: variable-name */
  function SignatureEventTarget() {
    _classCallCheck(this, SignatureEventTarget);

    /* tslint:disable: variable-name */
    _defineProperty(this, "_et", void 0);

    try {
      this._et = new EventTarget();
    } catch (_unused) {
      this._et = document;
    }
  }

  _createClass(SignatureEventTarget, [{
    key: "addEventListener",
    value: function addEventListener(type, listener, options) {
      this._et.addEventListener(type, listener, options);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      return this._et.dispatchEvent(event);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, callback, options) {
      this._et.removeEventListener(type, callback, options);
    }
  }]);

  return SignatureEventTarget;
}(); // src/throttle.ts


function throttle(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var previous = 0;
  var timeout = null;
  var result;
  var storedContext;
  var storedArgs;

  var later = function later() {
    previous = Date.now();
    timeout = null;
    result = fn.apply(storedContext, storedArgs);

    if (!timeout) {
      storedContext = null;
      storedArgs = [];
    }
  };

  return function wrapper() {
    var now = Date.now();
    var remaining = wait - (now - previous);
    storedContext = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    storedArgs = args;

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = now;
      result = fn.apply(storedContext, storedArgs);

      if (!timeout) {
        storedContext = null;
        storedArgs = [];
      }
    } else if (!timeout) {
      timeout = window.setTimeout(later, remaining);
    }

    return result;
  };
} // src/signature_pad.ts


var SignaturePad = /*#__PURE__*/function (_SignatureEventTarget) {
  _inherits(_SignaturePad, _SignatureEventTarget);

  var _super = _createSuper(_SignaturePad);

  /* tslint:enable: variable-name */
  function _SignaturePad(canvas) {
    var _options$throttle, _options$minDistance, _options$canvasContex;

    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, _SignaturePad);

    _this = _super.call(this);

    // Public stuff
    _defineProperty(_assertThisInitialized(_this), "dotSize", void 0);

    _defineProperty(_assertThisInitialized(_this), "minWidth", void 0);

    _defineProperty(_assertThisInitialized(_this), "maxWidth", void 0);

    _defineProperty(_assertThisInitialized(_this), "penColor", void 0);

    _defineProperty(_assertThisInitialized(_this), "minDistance", void 0);

    _defineProperty(_assertThisInitialized(_this), "velocityFilterWeight", void 0);

    _defineProperty(_assertThisInitialized(_this), "compositeOperation", void 0);

    _defineProperty(_assertThisInitialized(_this), "backgroundColor", void 0);

    _defineProperty(_assertThisInitialized(_this), "throttle", void 0);

    _defineProperty(_assertThisInitialized(_this), "canvasContextOptions", void 0);

    // Private stuff

    /* tslint:disable: variable-name */
    _defineProperty(_assertThisInitialized(_this), "_ctx", void 0);

    _defineProperty(_assertThisInitialized(_this), "_drawingStroke", false);

    _defineProperty(_assertThisInitialized(_this), "_isEmpty", true);

    _defineProperty(_assertThisInitialized(_this), "_dataUrl", void 0);

    _defineProperty(_assertThisInitialized(_this), "_dataUrlOptions", void 0);

    _defineProperty(_assertThisInitialized(_this), "_lastPoints", []);

    // Stores up to 4 most recent points; used to generate a new curve
    _defineProperty(_assertThisInitialized(_this), "_data", []);

    // Stores all points in groups (one group per line or dot)
    _defineProperty(_assertThisInitialized(_this), "_lastVelocity", 0);

    _defineProperty(_assertThisInitialized(_this), "_lastWidth", 0);

    _defineProperty(_assertThisInitialized(_this), "_strokeMoveUpdate", void 0);

    _defineProperty(_assertThisInitialized(_this), "_strokePointerId", void 0);

    _this.canvas = canvas;
    _this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
    _this.minWidth = options.minWidth || 0.5;
    _this.maxWidth = options.maxWidth || 2.5;
    _this.throttle = (_options$throttle = options.throttle) !== null && _options$throttle !== void 0 ? _options$throttle : 16;
    _this.minDistance = (_options$minDistance = options.minDistance) !== null && _options$minDistance !== void 0 ? _options$minDistance : 5;
    _this.dotSize = options.dotSize || 0;
    _this.penColor = options.penColor || "black";
    _this.backgroundColor = options.backgroundColor || "rgba(0,0,0,0)";
    _this.compositeOperation = options.compositeOperation || "source-over";
    _this.canvasContextOptions = (_options$canvasContex = options.canvasContextOptions) !== null && _options$canvasContex !== void 0 ? _options$canvasContex : {};
    _this._strokeMoveUpdate = _this.throttle ? throttle(_SignaturePad.prototype._strokeUpdate, _this.throttle) : _SignaturePad.prototype._strokeUpdate;
    _this._handleMouseDown = _this._handleMouseDown.bind(_assertThisInitialized(_this));
    _this._handleMouseMove = _this._handleMouseMove.bind(_assertThisInitialized(_this));
    _this._handleMouseUp = _this._handleMouseUp.bind(_assertThisInitialized(_this));
    _this._handleTouchStart = _this._handleTouchStart.bind(_assertThisInitialized(_this));
    _this._handleTouchMove = _this._handleTouchMove.bind(_assertThisInitialized(_this));
    _this._handleTouchEnd = _this._handleTouchEnd.bind(_assertThisInitialized(_this));
    _this._handlePointerDown = _this._handlePointerDown.bind(_assertThisInitialized(_this));
    _this._handlePointerMove = _this._handlePointerMove.bind(_assertThisInitialized(_this));
    _this._handlePointerUp = _this._handlePointerUp.bind(_assertThisInitialized(_this));
    _this._ctx = canvas.getContext("2d", _this.canvasContextOptions);

    _this.clear();

    _this.on();

    return _this;
  }

  _createClass(_SignaturePad, [{
    key: "clear",
    value: function clear() {
      var ctx = this._ctx,
          canvas = this.canvas;
      ctx.fillStyle = this.backgroundColor;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      this._data = [];

      this._reset(this._getPointGroupOptions());

      this._isEmpty = true;
      this._dataUrl = void 0;
      this._dataUrlOptions = void 0;
      this._strokePointerId = void 0;
    }
  }, {
    key: "redraw",
    value: function redraw() {
      var data = this._data;
      var dataUrl = this._dataUrl;
      var dataUrlOptions = this._dataUrlOptions;
      this.clear();

      if (dataUrl) {
        this.fromDataURL(dataUrl, dataUrlOptions);
      }

      this.fromData(data, {
        clear: false
      });
    }
  }, {
    key: "fromDataURL",
    value: function fromDataURL(dataUrl) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Promise(function (resolve, reject) {
        var image = new Image();
        var ratio = options.ratio || window.devicePixelRatio || 1;
        var width = options.width || _this2.canvas.width / ratio;
        var height = options.height || _this2.canvas.height / ratio;
        var xOffset = options.xOffset || 0;
        var yOffset = options.yOffset || 0;

        _this2._reset(_this2._getPointGroupOptions());

        image.onload = function () {
          _this2._ctx.drawImage(image, xOffset, yOffset, width, height);

          resolve();
        };

        image.onerror = function (error) {
          reject(error);
        };

        image.crossOrigin = "anonymous";
        image.src = dataUrl;
        _this2._isEmpty = false;
        _this2._dataUrl = dataUrl;
        _this2._dataUrlOptions = _objectSpread({}, options);
      });
    }
  }, {
    key: "toDataURL",
    value: function toDataURL() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "image/png";
      var encoderOptions = arguments.length > 1 ? arguments[1] : undefined;

      switch (type) {
        case "image/svg+xml":
          if (_typeof(encoderOptions) !== "object") {
            encoderOptions = void 0;
          }

          return "data:image/svg+xml;base64,".concat(btoa(this.toSVG(encoderOptions)));

        default:
          if (typeof encoderOptions !== "number") {
            encoderOptions = void 0;
          }

          return this.canvas.toDataURL(type, encoderOptions);
      }
    }
  }, {
    key: "on",
    value: function on() {
      this.canvas.style.touchAction = "none";
      this.canvas.style.msTouchAction = "none";
      this.canvas.style.userSelect = "none";
      var isIOS = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;

      if (window.PointerEvent && !isIOS) {
        this._handlePointerEvents();
      } else {
        this._handleMouseEvents();

        if ("ontouchstart" in window) {
          this._handleTouchEvents();
        }
      }
    }
  }, {
    key: "off",
    value: function off() {
      this.canvas.style.touchAction = "auto";
      this.canvas.style.msTouchAction = "auto";
      this.canvas.style.userSelect = "auto";
      this.canvas.removeEventListener("pointerdown", this._handlePointerDown);
      this.canvas.removeEventListener("mousedown", this._handleMouseDown);
      this.canvas.removeEventListener("touchstart", this._handleTouchStart);

      this._removeMoveUpEventListeners();
    }
  }, {
    key: "_getListenerFunctions",
    value: function _getListenerFunctions() {
      var _this$canvas$ownerDoc;

      var canvasWindow = window.document === this.canvas.ownerDocument ? window : (_this$canvas$ownerDoc = this.canvas.ownerDocument.defaultView) !== null && _this$canvas$ownerDoc !== void 0 ? _this$canvas$ownerDoc : this.canvas.ownerDocument;
      return {
        addEventListener: canvasWindow.addEventListener.bind(canvasWindow),
        removeEventListener: canvasWindow.removeEventListener.bind(canvasWindow)
      };
    }
  }, {
    key: "_removeMoveUpEventListeners",
    value: function _removeMoveUpEventListeners() {
      var _this$_getListenerFun = this._getListenerFunctions(),
          removeEventListener = _this$_getListenerFun.removeEventListener;

      removeEventListener("pointermove", this._handlePointerMove);
      removeEventListener("pointerup", this._handlePointerUp);
      removeEventListener("mousemove", this._handleMouseMove);
      removeEventListener("mouseup", this._handleMouseUp);
      removeEventListener("touchmove", this._handleTouchMove);
      removeEventListener("touchend", this._handleTouchEnd);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._isEmpty;
    }
  }, {
    key: "fromData",
    value: function fromData(pointGroups) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$clear = _ref.clear,
          clear = _ref$clear === void 0 ? true : _ref$clear;

      if (clear) {
        this.clear();
      }

      this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this));

      this._data = this._data.concat(pointGroups);
    }
  }, {
    key: "toData",
    value: function toData() {
      return this._data;
    }
  }, {
    key: "_isLeftButtonPressed",
    value: function _isLeftButtonPressed(event, only) {
      if (only) {
        return event.buttons === 1;
      }

      return (event.buttons & 1) === 1;
    }
  }, {
    key: "_pointerEventToSignatureEvent",
    value: function _pointerEventToSignatureEvent(event) {
      return {
        event: event,
        type: event.type,
        x: event.clientX,
        y: event.clientY,
        pressure: "pressure" in event ? event.pressure : 0
      };
    }
  }, {
    key: "_touchEventToSignatureEvent",
    value: function _touchEventToSignatureEvent(event) {
      var touch = event.changedTouches[0];
      return {
        event: event,
        type: event.type,
        x: touch.clientX,
        y: touch.clientY,
        pressure: touch.force
      };
    } // Event handlers

  }, {
    key: "_handleMouseDown",
    value: function _handleMouseDown(event) {
      if (!this._isLeftButtonPressed(event, true) || this._drawingStroke) {
        return;
      }

      this._strokeBegin(this._pointerEventToSignatureEvent(event));
    }
  }, {
    key: "_handleMouseMove",
    value: function _handleMouseMove(event) {
      if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
        this._strokeEnd(this._pointerEventToSignatureEvent(event), false);

        return;
      }

      this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    }
  }, {
    key: "_handleMouseUp",
    value: function _handleMouseUp(event) {
      if (this._isLeftButtonPressed(event)) {
        return;
      }

      this._strokeEnd(this._pointerEventToSignatureEvent(event));
    }
  }, {
    key: "_handleTouchStart",
    value: function _handleTouchStart(event) {
      if (event.targetTouches.length !== 1 || this._drawingStroke) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      this._strokeBegin(this._touchEventToSignatureEvent(event));
    }
  }, {
    key: "_handleTouchMove",
    value: function _handleTouchMove(event) {
      if (event.targetTouches.length !== 1) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      if (!this._drawingStroke) {
        this._strokeEnd(this._touchEventToSignatureEvent(event), false);

        return;
      }

      this._strokeMoveUpdate(this._touchEventToSignatureEvent(event));
    }
  }, {
    key: "_handleTouchEnd",
    value: function _handleTouchEnd(event) {
      if (event.targetTouches.length !== 0) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      this._strokeEnd(this._touchEventToSignatureEvent(event));
    }
  }, {
    key: "_getPointerId",
    value: function _getPointerId(event) {
      return event.persistentDeviceId || event.pointerId;
    }
  }, {
    key: "_allowPointerId",
    value: function _allowPointerId(event) {
      var allowUndefined = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (typeof this._strokePointerId === "undefined") {
        return allowUndefined;
      }

      return this._getPointerId(event) === this._strokePointerId;
    }
  }, {
    key: "_handlePointerDown",
    value: function _handlePointerDown(event) {
      if (this._drawingStroke || !this._isLeftButtonPressed(event) || !this._allowPointerId(event, true)) {
        return;
      }

      this._strokePointerId = this._getPointerId(event);
      event.preventDefault();

      this._strokeBegin(this._pointerEventToSignatureEvent(event));
    }
  }, {
    key: "_handlePointerMove",
    value: function _handlePointerMove(event) {
      if (!this._allowPointerId(event)) {
        return;
      }

      if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
        this._strokeEnd(this._pointerEventToSignatureEvent(event), false);

        return;
      }

      event.preventDefault();

      this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    }
  }, {
    key: "_handlePointerUp",
    value: function _handlePointerUp(event) {
      if (this._isLeftButtonPressed(event) || !this._allowPointerId(event)) {
        return;
      }

      event.preventDefault();

      this._strokeEnd(this._pointerEventToSignatureEvent(event));
    }
  }, {
    key: "_getPointGroupOptions",
    value: function _getPointGroupOptions(group) {
      return {
        penColor: group && "penColor" in group ? group.penColor : this.penColor,
        dotSize: group && "dotSize" in group ? group.dotSize : this.dotSize,
        minWidth: group && "minWidth" in group ? group.minWidth : this.minWidth,
        maxWidth: group && "maxWidth" in group ? group.maxWidth : this.maxWidth,
        velocityFilterWeight: group && "velocityFilterWeight" in group ? group.velocityFilterWeight : this.velocityFilterWeight,
        compositeOperation: group && "compositeOperation" in group ? group.compositeOperation : this.compositeOperation
      };
    } // Private methods

  }, {
    key: "_strokeBegin",
    value: function _strokeBegin(event) {
      var cancelled = !this.dispatchEvent(new CustomEvent("beginStroke", {
        detail: event,
        cancelable: true
      }));

      if (cancelled) {
        return;
      }

      var _this$_getListenerFun2 = this._getListenerFunctions(),
          addEventListener = _this$_getListenerFun2.addEventListener;

      switch (event.event.type) {
        case "mousedown":
          addEventListener("mousemove", this._handleMouseMove, {
            passive: false
          });
          addEventListener("mouseup", this._handleMouseUp, {
            passive: false
          });
          break;

        case "touchstart":
          addEventListener("touchmove", this._handleTouchMove, {
            passive: false
          });
          addEventListener("touchend", this._handleTouchEnd, {
            passive: false
          });
          break;

        case "pointerdown":
          addEventListener("pointermove", this._handlePointerMove, {
            passive: false
          });
          addEventListener("pointerup", this._handlePointerUp, {
            passive: false
          });
          break;

        default:
      }

      this._drawingStroke = true;

      var pointGroupOptions = this._getPointGroupOptions();

      var newPointGroup = _objectSpread(_objectSpread({}, pointGroupOptions), {}, {
        points: []
      });

      this._data.push(newPointGroup);

      this._reset(pointGroupOptions);

      this._strokeUpdate(event);
    }
  }, {
    key: "_strokeUpdate",
    value: function _strokeUpdate(event) {
      if (!this._drawingStroke) {
        return;
      }

      if (this._data.length === 0) {
        this._strokeBegin(event);

        return;
      }

      this.dispatchEvent(new CustomEvent("beforeUpdateStroke", {
        detail: event
      }));

      var point = this._createPoint(event.x, event.y, event.pressure);

      var lastPointGroup = this._data[this._data.length - 1];
      var lastPoints = lastPointGroup.points;
      var lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
      var isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;

      var pointGroupOptions = this._getPointGroupOptions(lastPointGroup);

      if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
        var curve = this._addPoint(point, pointGroupOptions);

        if (!lastPoint) {
          this._drawDot(point, pointGroupOptions);
        } else if (curve) {
          this._drawCurve(curve, pointGroupOptions);
        }

        lastPoints.push({
          time: point.time,
          x: point.x,
          y: point.y,
          pressure: point.pressure
        });
      }

      this.dispatchEvent(new CustomEvent("afterUpdateStroke", {
        detail: event
      }));
    }
  }, {
    key: "_strokeEnd",
    value: function _strokeEnd(event) {
      var shouldUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this._removeMoveUpEventListeners();

      if (!this._drawingStroke) {
        return;
      }

      if (shouldUpdate) {
        this._strokeUpdate(event);
      }

      this._drawingStroke = false;
      this._strokePointerId = void 0;
      this.dispatchEvent(new CustomEvent("endStroke", {
        detail: event
      }));
    }
  }, {
    key: "_handlePointerEvents",
    value: function _handlePointerEvents() {
      this._drawingStroke = false;
      this.canvas.addEventListener("pointerdown", this._handlePointerDown, {
        passive: false
      });
    }
  }, {
    key: "_handleMouseEvents",
    value: function _handleMouseEvents() {
      this._drawingStroke = false;
      this.canvas.addEventListener("mousedown", this._handleMouseDown, {
        passive: false
      });
    }
  }, {
    key: "_handleTouchEvents",
    value: function _handleTouchEvents() {
      this.canvas.addEventListener("touchstart", this._handleTouchStart, {
        passive: false
      });
    } // Called when a new line is started

  }, {
    key: "_reset",
    value: function _reset(options) {
      this._lastPoints = [];
      this._lastVelocity = 0;
      this._lastWidth = (options.minWidth + options.maxWidth) / 2;
      this._ctx.fillStyle = options.penColor;
      this._ctx.globalCompositeOperation = options.compositeOperation;
    }
  }, {
    key: "_createPoint",
    value: function _createPoint(x, y, pressure) {
      var rect = this.canvas.getBoundingClientRect();
      return new Point(x - rect.left, y - rect.top, pressure, /* @__PURE__ */new Date().getTime());
    } // Add point to _lastPoints array and generate a new curve if there are enough points (i.e. 3)

  }, {
    key: "_addPoint",
    value: function _addPoint(point, options) {
      var _lastPoints = this._lastPoints;

      _lastPoints.push(point);

      if (_lastPoints.length > 2) {
        if (_lastPoints.length === 3) {
          _lastPoints.unshift(_lastPoints[0]);
        }

        var widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2], options);

        var curve = Bezier.fromPoints(_lastPoints, widths);

        _lastPoints.shift();

        return curve;
      }

      return null;
    }
  }, {
    key: "_calculateCurveWidths",
    value: function _calculateCurveWidths(startPoint, endPoint, options) {
      var velocity = options.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - options.velocityFilterWeight) * this._lastVelocity;

      var newWidth = this._strokeWidth(velocity, options);

      var widths = {
        end: newWidth,
        start: this._lastWidth
      };
      this._lastVelocity = velocity;
      this._lastWidth = newWidth;
      return widths;
    }
  }, {
    key: "_strokeWidth",
    value: function _strokeWidth(velocity, options) {
      return Math.max(options.maxWidth / (velocity + 1), options.minWidth);
    }
  }, {
    key: "_drawCurveSegment",
    value: function _drawCurveSegment(x, y, width) {
      var ctx = this._ctx;
      ctx.moveTo(x, y);
      ctx.arc(x, y, width, 0, 2 * Math.PI, false);
      this._isEmpty = false;
    }
  }, {
    key: "_drawCurve",
    value: function _drawCurve(curve, options) {
      var ctx = this._ctx;
      var widthDelta = curve.endWidth - curve.startWidth;
      var drawSteps = Math.ceil(curve.length()) * 2;
      ctx.beginPath();
      ctx.fillStyle = options.penColor;

      for (var i = 0; i < drawSteps; i += 1) {
        var t = i / drawSteps;
        var tt = t * t;
        var ttt = tt * t;
        var u = 1 - t;
        var uu = u * u;
        var uuu = uu * u;
        var x = uuu * curve.startPoint.x;
        x += 3 * uu * t * curve.control1.x;
        x += 3 * u * tt * curve.control2.x;
        x += ttt * curve.endPoint.x;
        var y = uuu * curve.startPoint.y;
        y += 3 * uu * t * curve.control1.y;
        y += 3 * u * tt * curve.control2.y;
        y += ttt * curve.endPoint.y;
        var width = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);

        this._drawCurveSegment(x, y, width);
      }

      ctx.closePath();
      ctx.fill();
    }
  }, {
    key: "_drawDot",
    value: function _drawDot(point, options) {
      var ctx = this._ctx;
      var width = options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
      ctx.beginPath();

      this._drawCurveSegment(point.x, point.y, width);

      ctx.closePath();
      ctx.fillStyle = options.penColor;
      ctx.fill();
    }
  }, {
    key: "_fromData",
    value: function _fromData(pointGroups, drawCurve, drawDot) {
      var _iterator = _createForOfIteratorHelper(pointGroups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          var points = group.points;

          var pointGroupOptions = this._getPointGroupOptions(group);

          if (points.length > 1) {
            for (var j = 0; j < points.length; j += 1) {
              var basicPoint = points[j];
              var point = new Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);

              if (j === 0) {
                this._reset(pointGroupOptions);
              }

              var curve = this._addPoint(point, pointGroupOptions);

              if (curve) {
                drawCurve(curve, pointGroupOptions);
              }
            }
          } else {
            this._reset(pointGroupOptions);

            drawDot(points[0], pointGroupOptions);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "toSVG",
    value: function toSVG() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$includeBackgrou = _ref2.includeBackgroundColor,
          includeBackgroundColor = _ref2$includeBackgrou === void 0 ? false : _ref2$includeBackgrou,
          _ref2$includeDataUrl = _ref2.includeDataUrl,
          includeDataUrl = _ref2$includeDataUrl === void 0 ? false : _ref2$includeDataUrl;

      var pointGroups = this._data;
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      var minX = 0;
      var minY = 0;
      var maxX = this.canvas.width / ratio;
      var maxY = this.canvas.height / ratio;
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
      svg.setAttribute("viewBox", "".concat(minX, " ").concat(minY, " ").concat(maxX, " ").concat(maxY));
      svg.setAttribute("width", maxX.toString());
      svg.setAttribute("height", maxY.toString());

      if (includeBackgroundColor && this.backgroundColor) {
        var rect = document.createElement("rect");
        rect.setAttribute("width", "100%");
        rect.setAttribute("height", "100%");
        rect.setAttribute("fill", this.backgroundColor);
        svg.appendChild(rect);
      }

      if (includeDataUrl && this._dataUrl) {
        var _this$_dataUrlOptions, _this$_dataUrlOptions2, _this$_dataUrlOptions3, _this$_dataUrlOptions4, _this$_dataUrlOptions5;

        var ratio2 = ((_this$_dataUrlOptions = this._dataUrlOptions) === null || _this$_dataUrlOptions === void 0 ? void 0 : _this$_dataUrlOptions.ratio) || window.devicePixelRatio || 1;
        var width = ((_this$_dataUrlOptions2 = this._dataUrlOptions) === null || _this$_dataUrlOptions2 === void 0 ? void 0 : _this$_dataUrlOptions2.width) || this.canvas.width / ratio2;
        var height = ((_this$_dataUrlOptions3 = this._dataUrlOptions) === null || _this$_dataUrlOptions3 === void 0 ? void 0 : _this$_dataUrlOptions3.height) || this.canvas.height / ratio2;
        var xOffset = ((_this$_dataUrlOptions4 = this._dataUrlOptions) === null || _this$_dataUrlOptions4 === void 0 ? void 0 : _this$_dataUrlOptions4.xOffset) || 0;
        var yOffset = ((_this$_dataUrlOptions5 = this._dataUrlOptions) === null || _this$_dataUrlOptions5 === void 0 ? void 0 : _this$_dataUrlOptions5.yOffset) || 0;
        var image = document.createElement("image");
        image.setAttribute("x", xOffset.toString());
        image.setAttribute("y", yOffset.toString());
        image.setAttribute("width", width.toString());
        image.setAttribute("height", height.toString());
        image.setAttribute("preserveAspectRatio", "none");
        image.setAttribute("href", this._dataUrl);
        svg.appendChild(image);
      }

      this._fromData(pointGroups, function (curve, _ref3) {
        var penColor = _ref3.penColor;
        var path = document.createElement("path");

        if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
          var attr = "M ".concat(curve.startPoint.x.toFixed(3), ",").concat(curve.startPoint.y.toFixed(3), " C ").concat(curve.control1.x.toFixed(3), ",").concat(curve.control1.y.toFixed(3), " ").concat(curve.control2.x.toFixed(3), ",").concat(curve.control2.y.toFixed(3), " ").concat(curve.endPoint.x.toFixed(3), ",").concat(curve.endPoint.y.toFixed(3));
          path.setAttribute("d", attr);
          path.setAttribute("stroke-width", (curve.endWidth * 2.25).toFixed(3));
          path.setAttribute("stroke", penColor);
          path.setAttribute("fill", "none");
          path.setAttribute("stroke-linecap", "round");
          svg.appendChild(path);
        }
      }, function (point, _ref4) {
        var penColor = _ref4.penColor,
            dotSize = _ref4.dotSize,
            minWidth = _ref4.minWidth,
            maxWidth = _ref4.maxWidth;
        var circle = document.createElement("circle");
        var size = dotSize > 0 ? dotSize : (minWidth + maxWidth) / 2;
        circle.setAttribute("r", size.toString());
        circle.setAttribute("cx", point.x.toString());
        circle.setAttribute("cy", point.y.toString());
        circle.setAttribute("fill", penColor);
        svg.appendChild(circle);
      });

      return svg.outerHTML;
    }
  }]);

  return _SignaturePad;
}(SignatureEventTarget);

export { SignaturePad as default };